import { useMemo } from 'react';
import { useGetCountriesQuery } from '../domainsApi';

export function useGetCountriesList(): Array<{ value: string; label: string }> {
  const { data: countries } = useGetCountriesQuery();

  const countriesList = useMemo(() => {
    if (!countries) return [];

    if (Array.isArray(countries)) {
      return countries.map((country) => ({
        label: country.countryName,
        value: country.countryCode,
      }));
    }
    return Object.entries(countries).map(([code, name]) => ({
      label: name,
      value: code,
    }));
  }, [countries]);

  return countriesList;
}
